import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { SnackbarActions } from './snackbar.actions';
import { SharedSnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';

@Injectable()
export class SnackbarEffects {
  constructor(private actions$: Actions, private _snackBar: MatSnackBar) {}

  snackbarOpen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.snackbar_open),
        map(data => {
          return this._snackBar.openFromComponent(SharedSnackbarComponent, {
            data: data.snackbarData,
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right'
          });
        })
      ),
    { dispatch: false }
  );
}
